<template>
  <div class="personalData" style="padding-top: 0.49rem">
    <ul class="personalData_title">
      <li
        class="basic"
        :class="isActive == 1 ? 'active' : 'inActiveRight'"
        @click="isActive = 1"
      >
        基础资料
      </li>
      <li
        class="phone"
        :class="isActive == 2 ? 'active' : ''"
        @click="isActive = 2"
      >
        手机号变更
      </li>
    </ul>
    <!-- 基础资料部分 -->
    <div
      class="base_content"
      style="margin-top: 0.7rem"
      v-if="isActive == 1 ? true : false"
    >
      <div class="head">
        <div class="head_content">
          <p>头像</p>
          <div class="head_pic" @click.stop="$refs.uploder.chooseFile()">
            <img
              :src="
                baceInfo.pic
                  ? baceInfo.pic
                  : require('../../assets/img/personal/icon_portrait@2x.png')
              "
              alt=""
              style="width: 0.41rem; height: 0.41rem"
            />
            <van-uploader
              v-show="false"
              ref="uploder"
              :after-read="afterRead"
              :max-count="1"
            >
              <van-button class="upBtn"></van-button>
            </van-uploader>
          </div>
        </div>
      </div>
      <div class="form">
        <van-form @submit="onSubmit">
          <div>
            <van-field
              v-model="baceInfo.name"
              name="nickname"
              label="姓名"
              placeholder="请输入真实姓名"
              :rules="[{ required: true }]"
            />
            <div class="middle">
              <div class="alert">
                <img
                  src="../../assets/img/personal/icpn_warning@2x.png"
                  alt=""
                  style="width: 0.12rem; height: 0.12rem; margin-right: 0.08rem"
                />
                如不需要修改密码请勿填写
              </div>
            </div>
            <van-field
              v-model="baceInfo.password"
              type="password"
              name="password"
              label="旧密码"
              placeholder="请输入旧密码"
            />
            <van-field
              v-model="baceInfo.newpassword"
              type="password"
              name="newpassword"
              label="新密码"
              placeholder="请输入新密码"
            />
            <van-field
              v-model="rePassword"
              type="password"
              name="rePassword"
              label="确认密码"
              placeholder="请再次输入密码"
              @blur="checkPassword"
            />
          </div>
          <div class="btn">
            <van-button round block type="info" native-type="submit">
              保存资料
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
    <!-- 手机号变更部分 -->
    <div
      class="phone_content"
      style="margin-top: 0.7rem"
      v-if="isActive == 2 ? true : false"
    >
      <div class="form">
        <van-form @submit="onSubmitPhone">
          <div class="top">
            <van-field
              label="原手机号"
              name="cel"
              :value="baceInfo.phone"
              readonly
              class="read"
            />
            <van-field
              v-model="loginPass"
              type="password"
              name="password"
              label="登录密码"
              placeholder="请输入您的登录密码"
              :rules="[{ required: true }]"
            />
            <van-field
              v-model="tel"
              type="text"
              name="phone"
              label="新手机号"
              placeholder="请输入您的新手机号"
              :rules="[{ required: true }]"
            />
            <van-field
              v-model="code"
              name="code"
              label="验证码"
              center
              clearable
              placeholder="请输入您的验证码"
            >
              <template #button>
                <van-button
                  size="small"
                  type="primary"
                  native-type="button"
                  @click="sendFindCode(3)"
                  :disabled="isSend"
                  >{{ sendFindCodeText }}</van-button
                >
              </template>
            </van-field>
          </div>
          <div class="btn">
            <van-button round block type="info" native-type="submit">
              确认修改
            </van-button>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import {
  modifyPersonInfo,
  uploadAvatar,
  modifyPhone,
  getRegisterCode,
} from "@/api/home.js";

export default {
  data() {
    return {
      isActive: 1,
      rePassword: "",
      loginPass: "",
      tel: "",
      code: "",
      timeNum: 60,
      sendFindCodeText: "发送验证码",
      isSend: false,
      baceInfo: {}, // 将来像后端传的数据
      photo: [],
      path: "",
      pro: null,
    };
  },
  created() {
    if (this.$route.params.info) {
      this.baceInfo = this.$route.params.info;
      sessionStorage.setItem("info", JSON.stringify(this.$route.params.info));
    } else {
      this.baceInfo = JSON.parse(sessionStorage.getItem("info"));
    }
  },
  beforeDestroy() {
    sessionStorage.removeItem("info");
  },
  methods: {
    // 上传文件（头像）
    afterRead(file) {
      this.baceInfo.pic = file.content;
      const formData = new FormData();
      formData.append("pic", file.file);
      formData.append("path", "avatars");
      formData.append("type", "pic");
      this.pro = new Promise((resolve, reject) => {
        uploadAvatar(formData)
          .then((res) => {
            // code==1时，图片超过后台设置的最大限度
            if (res.data.code == 1) {
              Toast(res.data.msg);
            } else {
              this.path = res.data.backdata.path;
              resolve(res);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    // 超出大小
    // onOversize() {
    //   this.$toast("文件大小不能超过 500kb");
    // },
    // 检测手机号的格式
    isvalidatemobile(phone) {
      const list = [];
      let result = true;
      let msg = "";
      var isPhone = /^1[3456789]\d{9}$/;
      if (phone.length == 11) {
        if (!isPhone.test(phone)) {
          msg = "手机号码格式不正确";
          result = false;
        }
      } else {
        msg = "手机号码长度不为11位";
        result = false;
      }
      list.push(result);
      list.push(msg);
      return list;
    },
    // 发送验证码找回密码
    sendFindCode(val) {
      if (this.tel) {
        // 判断手机号是否符合规范
        const validate = this.isvalidatemobile(this.tel);
        if (validate[0]) {
          getRegisterCode({ phone: this.tel, type: val })
            .then((res) => {
              Toast("发送成功");
              this.setTimeFn();
            })
            .catch((err) => {
              Toast("发送失败请重新发送");
            });
        } else {
          Toast(validate[1]);
        }
      } else {
        Toast("请输入手机号");
      }
    },
    // 检测两次密码是否一致,检测密码长度是否符合规范6-12位
    checkPassword() {
      const reg = /^[\w]{6,12}$/;
      if (this.baceInfo.newpassword) {
        if (this.baceInfo.newpassword.match(reg)) {
          if (this.baceInfo.newpassword != this.rePassword) {
            Toast("两次输入的密码不一致");
          }
        } else {
          Toast("请输入6-12位密码");
        }
      }
    },
    // 发送验证码之后的倒计时
    setTimeFn() {
      setTimeout(() => {
        this.isSend = true;
        this.timeNum -= 1;
        this.sendFindCodeText = "重新获取(" + this.timeNum + ")";
        if (this.timeNum == 0) {
          this.isSend = false;
          this.timeNum = 60;
          this.sendFindCodeText = "发送验证码";
        } else {
          this.setTimeFn();
        }
      }, 1000);
    },
    onSubmit(values) {
      Promise.all([this.pro]).then((res) => {
        let flag = false;
        if (values.newpassword && values.rePassword) {
          if (values.newpassword !== values.rePassword) {
            return this.checkPassword();
          } else {
            flag = true;
          }
        }
        // 基础资料
        modifyPersonInfo({
          ...values,
          pic: this.path,
        })
          .then((res) => {
            if (flag) {
              if (res.data.code == 0) {
                this.$toast("密码修改成功，请重新登录");
                sessionStorage.clear();
                localStorage.clear();
                setTimeout(() => {
                  this.$router.push("/login");
                }, 1000);
              } else {
                this.$toast(res.data.msg);
              }
            } else {
              this.$toast(res.data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      });
    },
    onSubmitPhone(val) {
      modifyPhone(val).then((res) => {
        this.$toast(res.data.msg);
        if (res.data.code == 0) {
          this.tel = "";
          this.code = "";
          this.loginPass = "";
        }
      });
    },
  },
};
</script>

<style lang='scss'>
.personalData {
  .personalData_title {
    width: 100%;
    height: 0.59rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #ffffff;
    position: fixed;
    z-index: 1;
    top: 0.49rem;
    li {
      width: 1.41rem;
      height: 0.29rem;
      line-height: 0.29rem;
      text-align: center;
      border: 1px solid #35353d;
      font-size: 0.12rem;
      color: #333333;
      &.basic {
        border-radius: 0.15rem 0rem 0rem 0.15rem;
      }
      &.phone {
        border-left: none;
        border-radius: 0px 0.15rem 0.15rem 0px;
      }
      &.active {
        background: linear-gradient(0deg, #d1ad79 0%, #efd7b1 100%);
        border: 1px solid transparent;
        border-image: linear-gradient(0deg, #dfb981 0%, hsl(37, 68%, 82%) 100%);
        color: #93683d;
      }
      &.inActiveRight {
        border-right: none;
      }
    }
  }
  .base_content {
    .head {
      padding-left: 0.15rem;
      background: #ffffff;
      .head_content {
        height: 0.73rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #f3f1f4;
        font-size: 0.14rem;
        color: #333333;
        padding-right: 0.15rem;
        .head_pic {
          display: flex;
          align-items: center;
          background: url("../../assets/img/personal/btn_more@2x.png") no-repeat
            center right;
          background-size: 0.06rem 0.09rem;
          padding-right: 0.1rem;
          // .van-uploader {
          //   overflow: hidden;
          //   border: none;
          //   width: 0.1rem;
          //   height: 0.1rem;
          //   padding: 0.15rem;
          //   background: url("../../assets/img/personal/btn_more@2x.png")
          //     no-repeat center center;
          //   background-size: 0.06rem 0.09rem;
          //   .upBtn {
          //     width: 100%;
          //     height: 100%;
          //     border: none;
          //     opacity: 0;
          //   }
          // }
        }
      }
    }
  }
  .form {
    .middle {
      width: 100%;
      height: 0.51rem;
      padding-top: 0.11rem;

      .alert {
        display: flex;
        align-items: center;
        width: 100%;
        height: 0.4rem;
        background: #f6e3ca;
        padding-left: 0.15rem;
        color: #93673d;
        line-height: 0.4rem;

        font-size: 0.12rem;
      }
    }
    .van-form {
      height: 4.6rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
    .van-cell {
      font-size: 0.14rem;
      padding: 0.1rem 0 0.1rem 0.15rem;
      color: #333333;
      .van-field__button {
        padding: 0;
        .van-button--small {
          height: 0.24rem;
          background: #f0d8b1;
          border-radius: 0.02rem;
          font-size: 0.12rem;
          color: #93683d;
          border: none;
          margin-right: 0.15rem;
          margin-left: 0.15rem;
        }
      }
    }
    .van-field__label {
      color: #333333;
      width: 0.8rem;
      margin-right: 0;
    }
    .van-cell::after {
      right: 0;
    }
    .btn {
      display: flex;
      justify-content: center;
      margin-bottom: 0.22rem;
      .van-button--info {
        width: 2.72rem;
        height: 0.44rem;
        background: linear-gradient(0deg, #d1ad79 0%, #efd7b1 100%);
        border-radius: 0.22rem;
        border: none;
        font-size: 0.16rem;
        font-weight: bold;
        color: #93673d;
      }
    }
  }
  .phone_content {
    .van-form {
      height: 5.33rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  }
}
</style>
